export const situationsFive = [
  {
    id: 1,
    text: "Your brother wants to get admission in a medical college but his marks fall short by 1% for admission. You...",
    response: "Motivated him to reappear for the exam and score well.",
  },
  {
    id: 2,
    text: "He is traveling in a train. At one of the stations he came down to buy some fruits and when he turned back, the train had already left. He...",
    response: "He took a cab and boarded in train at next station.",
  },
  {
    id: 3,
    text: "You are a guest at a dinner. The host asks you to take one more chapati after your stomach is full. You would...",
    response: "Declined politely and appreciated the food and the host.",
  },
  {
    id: 4,
    text: "His mother was seriously ill and his boss didn't grant him leave. He...",
    response:
      "He asked brother to take care and finished the work and convinced boss for leave and went to meet mother.",
  },
  {
    id: 5,
    text: "He proposed to invite a political leader to preside over the annual day celebration but others were against it. He...",
    response:
      "He listened to other's suggestion and accepted the majority decision.",
  },
  {
    id: 6,
    text: "He planned to take admission in M.Sc. But his father was not able to pay for his session, due to his sister's marriage. He...",
    response:
      "He took help from friends and started giving home tuition to fund his education.",
  },
  {
    id: 7,
    text: "He hears a cry of fire-fire from the neighboring house. He...",
    response:
      "He immediately rushed and switched off the power supply, ensured evacuation and tried to extinguish the fire and if in large scale, called the fire brigade.",
  },
  {
    id: 8,
    text: "He is gone for an outing with friends. On a boat he lost his balance and fall in the sea and he does not know swimming. He...",
    response:
      "He shouted for help and hold the boat and thereafter hand of a friend and came up safely.",
  },
  {
    id: 9,
    text: "His friends forced him to drink beer when he was not in the mood of drinking. He...",
    response: "He politely declined, took coke and enjoyed together.",
  },
  {
    id: 10,
    text: "While returning from a picnic, it starts getting dark and he has lost his way. He would...",
    response: " He would open Google map and find the way.",
  },
  {
    id: 11,
    text: "You caught a pickpocket red-handed. What would you do...",
    response: "Hand over to police.",
  },
  {
    id: 12,
    text: "He is called for interview for a job he badly needed. But the same day was his final exam...",
    response:
      "Requested reschedule of interview for the evening and attended it after giving the exam.",
  },
  {
    id: 13,
    text: "He suddenly saw a snake creeping towards his foot at his house. He...",
    response:
      "He jumped to a safe place, alerted family members and killed the snake with a stick.",
  },
  {
    id: 14,
    text: "He found his friend struggling to pass the re-examination, in which he easily got passed. He...",
    response:
      "Motivated him, helped him by sharing his notes and strategies and helped him pass the exam.",
  },
  {
    id: 15,
    text: "He and his sister were passing through a thick forest on a scooter. The scooter was stopped at gunpoint for ransom. He...",
    response:
      " He gave the ransom amount, later informed police, covertly followed goon and got them arrested.",
  },
  {
    id: 16,
    text: "He was forced to join the army but he was not interested. He...",
    response:
      "He told his interest and career plan to parents and convinced them to let him pursue his dreams.",
  },
  {
    id: 17,
    text: "His father slipped on a banana peel and hurt his Back badly as they were hurrying towards the railway station to catch the only train to their village. He...",
    response:
      "He took him to a nearby hospital, admitted him and took another train when he recovered",
  },
  {
    id: 18,
    text: "He saw a snake moving near to the bed while his younger brother was sleeping when he enters his room. He...",
    response:
      " He alerted brother, threw bedsheet on the snake and killed the snake.",
  },
  {
    id: 19,
    text: "He was traveling in a boat with his friends when water started gushing inside the boat due to a small hole. He...",
    response:
      "He blocked the hole with wood/cloth and took the water out of the boat.",
  },
  {
    id: 20,
    text: "You saw a small boy pushing another into water pool you...",
    response:
      "Stopped them and informed their parents and left them under their supervision.",
  },
  {
    id: 21,
    text: "As a young boy, he had gone to see a fair and got separated from his group. He...",
    response: "He announced on the loudspeaker and meet the group thereafter.",
  },
  {
    id: 22,
    text: "His commander ordered him to attack the hide-outs of infiltrators by leading his coy. He...",
    response:
      "He prepared a team, full proof plan and launched surprise attack as per plan and killed the infiltrators.",
  },
  {
    id: 23,
    text: "A rowdy in his area is trying to set up an illegal liquor shop. He...",
    response:
      "He complaint to SP, gather people to protest and stopped setting up of shop.",
  },
  {
    id: 24,
    text: "You hear a knock on your door at midnight and finds out a man with a gun in his hand is asking for a glass of water. You...",
    response: "Asked for his police ID and gave him water.",
  },
  {
    id: 25,
    text: "You are living in a college hostel. The dal served to you in the mess has a lot of stones. What would you do...",
    response:
      "Took dal to mess in charge, lodge complaint and got new cook appointed.",
  },
  {
    id: 26,
    text: "You find it rather difficult to get admission for a study course of your choice, you would...",
    response:
      "Took instruction from seniors and internet, made a strategy, put on extra effort, and pass the exam.",
  },
  {
    id: 27,
    text: "One of his colleagues wanted him to intervene to restore good relations between him and his wife. He...",
    response:
      "He suggested to spend time together, arranged a good holiday for them and helped them in removing misunderstanding.",
  },
  {
    id: 28,
    text: "He has to go to attend the SSB after two days at Bangalore from Delhi but there is a railway strike and he has not had enough money to buy a plane ticket. He...",
    response:
      "Asked for money from a friend and booked a flight ticket and later returned the money.",
  },
  {
    id: 29,
    text: "One evening a stranger comes and requests for a night stay in your house. So you...",
    response:
      "Asked his identity and reason for stay and helped him book a hotel nearby.",
  },
  {
    id: 30,
    text: "While playing hockey match, one of the opponents abused him. He...",
    response: "He kept calm, focused on the game and defeated the opponent.",
  },
  {
    id: 31,
    text: "As head of PMO, he realized that one of his own trusted employees was indulging in espionage. He...",
    response: "He suspended him, took stringent action, and hold an inquiry.",
  },
  {
    id: 32,
    text: "A day before his trip, he came to know that the selected place is affected by the cyclone. He...",
    response: "He searched a new place, informed group and enjoyed the trip.",
  },
  {
    id: 33,
    text: "His village is going to be flooded in next one hour. He...",
    response:
      "He alerted villagers to carry valuables and vacant village, informed authority, helped in making arrangements and evacuation. ",
  },
  {
    id: 34,
    text: "He hears his neighbors screaming `thief- thief` at mid-night. He...",
    response:
      "He informed security and directed to close exit points, informed the police and got them arrested.",
  },
  {
    id: 35,
    text: "He was in Nagaland jungle and he saw six tribals with lathis rushing to him. He...",
    response:
      "He stopped them, assured them no harm, told them he lost his way and went out safely.",
  },
  {
    id: 36,
    text: "You appeared in a competitive exam and you noticed that the minister's son got a copy of solution from outside. You...",
    response:
      "Hinted invigilator about it, got him caught and focused on the exam.",
  },
  {
    id: 37,
    text: "He joined his unit on posting but realized that his seniors were adopting a compromising attitude leading to indiscipline amongst troops. He...",
    response:
      "He tightens the rules, took action against interdisciplinary and reinstated the discipline within troops.",
  },
  {
    id: 38,
    text: "His father has decided to change his will in the name of his younger brother. He...",
    response:
      "He supported his father’s decision and congratulated his brother.",
  },
  {
    id: 39,
    text: "He was preparing for the exam, at 10 o'clock there is an electric failure in his colony. He...",
    response:
      "Used backup, informed powerhouse, got the issue fixed and continued studying.",
  },
  {
    id: 40,
    text: "He is in a lift with a pretty girlfriend when the electricity fails. He...",
    response:
      "Pressed the emergency, waited for evacuation and meanwhile enjoyed the company.",
  },
  {
    id: 41,
    text: "His 3 years old younger brother was missing from home. He...",
    response: "He informed police, searched in the locality and found him.",
  },
  {
    id: 42,
    text: "He was going for the SSB and on the way, he saw a person seriously injured and nobody was there to help him . He...",
    response:
      "He immediately called an ambulance, admitted him, informed family members and went to the SSB. ",
  },
  {
    id: 43,
    text: "He was about to lose a point in a discussion. He...",
    response:
      "Remained calm, came back with strong fact and secured his point.",
  },
  {
    id: 44,
    text: "She got selected in defence and now her father forbids her to join the defence. She would...",
    response:
      "She told father about her dreams and  lifestyle in defence forces and prospect, convinced him and joined forces.",
  },
  {
    id: 45,
    text: "You are moving along with a convoy to forward area and sitting at the back of the vehicle. You noticed a flag car chasing you. You...",
    response:
      "Informed convoy commander, alerted troops, and followed commander's orders.",
  },
  {
    id: 46,
    text: "Your friend dies in a drowning tragedy. You...",
    response:
      "Consoled the family and helped and supported them in every possible manner.",
  },
  {
    id: 47,
    text: "In a company of strangers you feel...",
    response: "Energetic in making good and cordial relation with others.",
  },
  {
    id: 48,
    text: "You opposed strike in college and you are beaten up by the strikers (your colleagues). You...",
    response:
      "Lodged complaint in internal complaint committee and got defaulters terminated.",
  },
  {
    id: 49,
    text: "His younger brother gets into bad practice of alcoholism. He...",
    response:
      "He informed parents, counsel and convinced him for rehab for the breakdown of addiction. ",
  },
  {
    id: 50,
    text: "While traveling in a train, you observe some college students pulling the alarm chain simply to get down at their desired point. You...",
    response:
      "Confronted them with co-passengers help and stopped them from pulling the chain and warned them for their action.",
  },
  {
    id: 51,
    text: "He wants to participate in intercollege drama competition as main lead but the role he is offered is of villain. He will...",
    response: " He accepted the role and gave his best performance.",
  },
  {
    id: 52,
    text: "While traveling in a bus he saw a man pushing another man down and injuring him. He...",
    response:
      "He nabbed him, informed the police and took the injured to the hospital.",
  },
  {
    id: 53,
    text: "She had a misunderstanding with her sister-in-law. She would...",
    response:
      "Took help from her husband, talked to her and removed misunderstanding.",
  },
  {
    id: 54,
    text: " She was working on a good post but her would-be husband told her to quit the job. She...",
    response: "She didn’t quit the job and also didn’t marry him.",
  },
  {
    id: 55,
    text: "Drought conditions were prevailing in his village. He...",
    response:
      "Formed an NGO, collaborated with the local authority, launched several water conservation plans and spread awareness.",
  },
  {
    id: 56,
    text: "His friends are not willing to donate blood due to the fear of health hazards. He...",
    response:
      "He explained to them about precaution and safety measures are taken while donating and convinced them for donation.",
  },
  {
    id: 57,
    text: "There was an urgent need of money in her In-laws house. She...",
    response: "Helped them and provided other assistance, if necessary.",
  },
  {
    id: 58,
    text: "On a windy afternoon his neighbor's house caught fire. All his friends were sleeping on the first floor. He...",
    response:
      "He alerted friends and neighbor, called the fire brigade, helped in evacuation and helped firefighters in extinguishing the fire.",
  },
  {
    id: 59,
    text: "A man had fallen into the sea when the sea was rough. He...",
    response:
      "He informed lifeguard and other people, took their help and rescued him.",
  },
  {
    id: 60,
    text: "She had quarreled with her husband. She would...",
    response:
      "She gave time and space to settle things and thereafter, talk to him and removed misunderstandings.",
  },
  {
    id: 60,
    text: "She had quarreled with her husband. She would...",
    response:
      "She gave time and space to settle things and thereafter, talk to him and removed misunderstandings.",
  },
];
